module.exports = __webpack_public_path__ + "img/demo-ava.a5086149.jpeg";